import { FC, useState } from "react"
import { FormEntryField, Nullable } from "../../../core/type"
import { StylesFindByVendor } from "../graphql/style.graphql"
import { useQuery } from "@apollo/client"
import { AutoComplete } from "antd"

export type StylesByVendorAutoCompleteProps = FormEntryField<string> & {
  vendorId: Nullable<number>
  isActive: boolean
}

export const StylesByVendorAutoComplete: FC<StylesByVendorAutoCompleteProps> = ({ vendorId, value, onChange, isActive }) => {
  const [search, setSearch] = useState<string>()
  const { data } = useQuery(StylesFindByVendor, {
    variables: {
      vendorId: vendorId ?? 0,
    },
    skip: !vendorId,
  })

  return (
    <AutoComplete<string>
      className='w-100'
      disabled={!isActive}
      onSearch={setSearch}
      value={value}
      onChange={value => onChange!(value as string)}
      options={vendorId
        ? data?.stylesFindByVendor
          .filter(style => style.toLowerCase().includes(search?.toLowerCase() ?? ''))
          .map(style => ({
            label: style,
            value: style,
          }))
        : []
      }
    />
  )
}